import { BehaviorSubject } from 'rxjs';
import config from '../../config/index';
import requestOptions from '@/helpers/RequestOptions';
import handleResponse from '@/helpers/HandleResponses';


export const skillsService = {
    addSkillType,
    getSkillTypes,
    updateSkillType,
    removeSkillType,
    addSkill,
    getSkills,
    removeSkill,
    updateSkill,
    addskillGrade,
    getskillGrades,
    removeskillGrade,
    updateskillGrade,
    getTerminationTypes,
    addTerminationType,
    updateTerminationType,
    removeTerminationType,
    getActivities,
    addActivity,
    updateActivity,
    removeActivity,
    addResource,
    getResources,
    updateResource,
    removeResource
}

function addSkillType(name, companyId) {
    var load = {
        name,
        companyId
    }
    return fetch(`${config.apiurl}/Skill/createSkillType`, requestOptions.post(load))
        .then(handleResponse)
        .then(id => {
            return id;
        });
}

function getSkillTypes(id) {
    return fetch(`${config.apiurl}/Skill/getSkillTypes?id=${id}`, requestOptions.get())
        .then(handleResponse)
        .then(model => {
            return model;
        });
}

function updateSkillType(id, companyId, name) {
    var load = {
        id,
        companyId,
        name
    }
    return fetch(`${config.apiurl}/Skill/updateSkillType`, requestOptions.put(load))
        .then(handleResponse)
        .then(id => {
            return id;
        });
}

function removeSkillType(id) {
    return fetch(`${config.apiurl}/Skill/deleteSkillType?id=${id}`, requestOptions.delete())
        .then(handleResponse)
        .then(id => {
            return id;
        });
}

function addSkill(companyId, name, description, type) {
    var req = {
        companyId,
        name,
        description,
        type
    }
    return fetch(`${config.apiurl}/Skill/createSkill`, requestOptions.post(req))
        .then(handleResponse)
        .then(id => {
            return id;
        });
}

function getSkills(id) {
    return fetch(`${config.apiurl}/Skill/getSkills/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(model => {
            return model
        });
}

function removeSkill(id) {
    return fetch(`${config.apiurl}/Skill/deleteSkill?id=${id}`, requestOptions.delete())
        .then(handleResponse)
        .then(id => {
            return id;
        });
}

function updateSkill(id, companyId, name, description, type) {
    var load = {
        id,
        companyId,
        name,
        description,
        type
    }
    return fetch(`${config.apiurl}/Skill/updateSkill`, requestOptions.put(load))
        .then(handleResponse)
        .then(id => {
            return id;
        });
}

function addskillGrade(companyId, name, rating, type) {
    var req = {
        companyId,
        name,
        rating,
        type
    }
    return fetch(`${config.apiurl}/Skill/createSkillGrade`, requestOptions.post(req))
        .then(handleResponse)
        .then(id => {
            return id;
        });
}

function getskillGrades(companyId) {
    return fetch(`${config.apiurl}/Skill/getSkillGrades/${companyId}`, requestOptions.get())
        .then(handleResponse)
        .then(model => {
            return model
        });
}

function removeskillGrade(id) {
    return fetch(`${config.apiurl}/Skill/deleteSkillGrade?id=${id}`, requestOptions.delete())
        .then(handleResponse)
        .then(id => {
            return id;
        });
}

function updateskillGrade(id, companyId, name, rating, type) {
    var load = {
        id,
        name,
        companyId,
        rating,
        type
    }
    return fetch(`${config.apiurl}/Skill/updateSkillGrade`, requestOptions.put(load))
        .then(handleResponse)
        .then(id => {
            return id;
        });
}

function getTerminationTypes() {
  return fetch(`${config.apiurl}/Miscellaneous/getTerminationTypes`, requestOptions.get())
      .then(handleResponse)
      .then(model => {
          return model;
      });
}

function addTerminationType(name) {
  var req = {
    name
  }
  return fetch(`${config.apiurl}/Miscellaneous/createTerminationType`, requestOptions.post(req))
      .then(handleResponse)
      .then(id => {
          return id;
      });
}
function updateTerminationType(req) {
    
    return fetch(`${config.apiurl}/Miscellaneous/updateTerminationType`, requestOptions.put(req))
        .then(handleResponse)
        .then(id => {
            return id;
        });
  }

  function removeTerminationType(id) {
    return fetch(`${config.apiurl}/Miscellaneous/deleteTerminationType?id=${id}`, requestOptions.delete())
        .then(handleResponse)
        .then(id => {
            return id;
        });
}

function getActivities(id) {
    return fetch(`${config.apiurl}/Miscellaneous/getactivities/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(model => {
            return model;
        });
  }
  
  function addActivity(name, type, description, companyId) {
    var req = {
      name,
      type,
      description,
      companyId
    }
    return fetch(`${config.apiurl}/Miscellaneous/createActivity`, requestOptions.post(req))
        .then(handleResponse)
        .then(id => {
            return id;
        });
  }
  function updateActivity(req) {
      
      return fetch(`${config.apiurl}/Miscellaneous/updateActivity`, requestOptions.put(req))
          .then(handleResponse)
          .then(id => {
              return id;
          });
    }
  
    function removeActivity(id) {
      return fetch(`${config.apiurl}/Miscellaneous/deleteActivity?id=${id}`, requestOptions.delete())
          .then(handleResponse)
          .then(id => {
              return id;
          });
  }
  function addResource(name, type, cv, companyId) {
    let formData = new FormData();
    formData.append('Name', name);
    formData.append('CompanyId', companyId)
    formData.append('Type', type);
    formData.append('Uploadfile', cv);
    return fetch(`${config.apiurl}/Miscellaneous/createResource`, requestOptions.postForm(formData))
        .then(handleResponse)
        .then(id => {

            return id;
        });
}

function getResources(companyId) {
    return fetch(`${config.apiurl}/Miscellaneous/getresources/${companyId}`, requestOptions.get())
        .then(handleResponse)
        .then(model => {

            return model;
        });
}

function updateResource(id, name, type, cv, companyId) {
    let formData = new FormData();
    formData.append('Id', id);
    formData.append('Name', name);
    formData.append('Type', type);
    formData.append('CompanyId', companyId);
    formData.append('Uploadfile', cv);
    return fetch(`${config.apiurl}/Miscellaneous/updateResource`, requestOptions.putForm(formData))
        .then(handleResponse)
        .then(id => {

            return id;
        });
}

function removeResource(id) {
    return fetch(`${config.apiurl}/Miscellaneous/deleteResource?id=${id}`, requestOptions.delete())
        .then(handleResponse)
        .then(id => {
            return id;
        });
}


// WEBPACK FOOTER //
// ./src/services/skillsService.js